import { useEffect } from 'react'
import { useAnimation } from 'framer-motion'
import { IPublicStruct } from 'interfaces/IPublicStruct'
import UserInfoState from './UserInfoState'
import { UserMeta } from '../UserMeta/UserMeta'
import { UserInfoBlock } from './UserInfoBlock'
import { Theme } from 'theme'

// icons
import DiscordIcon from 'components/StaticIcons/Discord'

import {
  Wrapper,
  Section,
  SectionTitle,
  Grid,
  Contacts,
  Username,
  Copy
} from './styles'
import Country from 'components/Country'
import Plug from 'components/Plug'

// icons
import ColorSplash from 'components/StaticIcons/ColorSplash'
import CopyIcon from 'components/StaticIcons/Copy'

interface props {
  data: IPublicStruct;
}

export function UserInfo({ data: { user, info } }: props) {

  const control = useAnimation()
  const isOpen = UserInfoState.isOpen

  useEffect(() => {

    control.start( isOpen ? 'show' : 'hide' );

  }, [isOpen]);

  const languagesList = user.languages.map((item, index) => {
    return <Country name={item} key={index} />
  })

  return (
    <Wrapper
      variants={Theme.motion.openChat} initial="start" animate={control} transition={Theme.motion.userInfo}
    >

      <Section>

        <UserMeta user={user} />
        <SectionTitle>Player details</SectionTitle>

        <Grid>
          {info.map(({ title, description }, index) => {
            return <UserInfoBlock key={index} title={title} description={description} />
          })}

          <UserInfoBlock title="Languages" description={languagesList} />
        </Grid>

        <Contacts>
          <DiscordIcon color="#fff" />
          <Username>Dirr24 #4143</Username>
          <Copy> <CopyIcon /> </Copy>
        </Contacts>

      </Section>

      <Section>
        <SectionTitle>Game statistic</SectionTitle>
        <Plug image={<ColorSplash />} title="Coming Soon" description="Statistics is under development." />
      </Section>

    </Wrapper>
  )
}